import actionTypes from './actionTypes';
import type { ILoadDataRequestPayload, ILoadDataSuccessPayload, IRateCardEngineOption } from './types';

const actions = {
  loadFormDataRequest: () => ({ type: actionTypes.LOAD_FORM_DATA_REQUEST }),

  loadFormDataSuccess: (payload: { engines: IRateCardEngineOption[] }) => ({
    type: actionTypes.LOAD_FORM_DATA_SUCCESS,
    payload,
  }),

  loadFormDataError: () => ({ type: actionTypes.LOAD_FORM_DATA_ERROR }),

  loadDataRequest: (payload: ILoadDataRequestPayload) => ({
    type: actionTypes.LOAD_DATA_REQUEST,
    payload,
  }),

  loadDataSuccess: (payload: ILoadDataSuccessPayload) => ({
    type: actionTypes.LOAD_DATA_SUCCESS,
    payload,
  }),

  loadDataError: () => ({
    type: actionTypes.LOAD_DATA_ERROR,
  }),

  deleteRequest: (payload: { id: string }) => ({
    type: actionTypes.DELETE_REQUEST,
    payload,
  }),

  deleteSuccess: () => ({ type: actionTypes.DELETE_SUCCESS }),

  deleteError: () => ({ type: actionTypes.DELETE_ERROR }),

  clearStore: () => ({
    type: actionTypes.CLEAR_STORE,
  }),
};

export default actions;
